module.exports = __webpack_public_path__ + "img/result-detail-output-outleft01.edd5c0cf.svg";